import utils from '@/components/tools/utils'

function getDiffInDays (date1, date2) {
  // Convert dates to UTC timestamps
  const utc1 =
    Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
  const utc2 =
    Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate())

  // Calculate the time difference in milliseconds
  const timeDiff = Math.abs(utc2 - utc1)

  // console.log('diff in days', utc1, utc2, timeDiff)
  // Convert milliseconds to days
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
}

function getAvailabilityConfirmed (date, that) {
  let color = 'muted'
  if (!date) {
    return {
      value: that.$t('auction.history.pending'),
      tone: color
    }
  }

  const now = new Date()
  const availabilityConfirmed = new Date(date)

  const diffInDays = getDiffInDays(availabilityConfirmed, now)

  let value = '-'
  if (diffInDays === 0) {
    color = 'success'
    value = that.$t('auction.history.today_at_x', [utils.formatHoursAndMinutes(availabilityConfirmed)])
  } else if (diffInDays === 1) {
    value = that.$t('auction.history.yesterday_at_x', [utils.formatHoursAndMinutes(availabilityConfirmed)])
    color = 'success'
  } else if (diffInDays === 2) {
    color = 'amber'
    value = that.$t('auction.history.x_days_ago_at_y', [
      diffInDays,
      utils.formatHoursAndMinutes(availabilityConfirmed)])
  } else {
    value = that.$t('auction.history.pending')
  }

  return {
    value,
    tone: color
  }
}

function getSellerLastOnline (sellerLastOnline, that) {
  if (sellerLastOnline) {
    let color = 'muted'
    const date = sellerLastOnline
    const now = new Date()
    const lastOnlineDate = new Date(date)
    const diffInMs = now - lastOnlineDate
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

    if (diffInDays <= 1) {
      color = 'success'
    } else if (diffInDays <= 2) {
      color = 'amber'
    }

    let value = '-'
    if (diffInDays === 0) {
      value = that.$t('auction.history.today')
    } else if (diffInDays === 1) {
      value = that.$t('auction.history.yesterday')
    } else {
      value = that.$t('auction.history.x_days_ago', [diffInDays])
    }

    return {
      value,
      tone: color
    }
  } else {
    return {
      value: '-',
      tone: null
    }
  }
}

function getNumberOfAuctions (numberOfAuctions) {
  let color = 'success'
  let amount = 1
  if (numberOfAuctions > 5) {
    color = 'muted'
    amount = ' >5'
  } else if (numberOfAuctions >= 5) {
    color = 'muted'
    amount = numberOfAuctions
  } else if (numberOfAuctions >= 3) {
    color = 'amber'
    amount = numberOfAuctions
  } else if (numberOfAuctions >= 1) {
    amount = numberOfAuctions
  }

  return {
    value: amount,
    tone: color
  }
}

function getLastRejectedBid (date, bid) {
  if (date && bid) {
    return {
      value: utils.formatCurrency(bid),
      tone: utils.formatDate(date)
    }
  } else {
    return {
      value: '-',
      tone: null
    }
  }
}

const auctionHistory = {
  getAvailabilityConfirmed,
  getSellerLastOnline,
  getNumberOfAuctions,
  getLastRejectedBid
}

export default auctionHistory
